<ng-container *transloco="let t">
  <div
    #componentWrapper
    class="content"
    [class.widescreen]="(biggerThan$ | async)?.sm"
    [class.single-header]="(biggerThan$ | async)?.mobileL">
    <div #scrollElement class="main-scroll" id="mainAppScroll" cdk-scrollable>
      <main class="wrapper">
        <!--Products Link Bar -->
        @if ((biggerThan$ | async)?.mobileL) {
          <app-navigation-bar />
        }

        <app-best-deals-picker />

        <app-highlights-banner />

        <app-best-category-deals-picker [category]="'SMARTPHONE'" />

        <app-best-category-deals-picker [category]="'LAPTOP'" />

        <app-best-category-deals-picker [category]="'TABLET'" />

        <!-- Category Picker -->
        <!-- Best Sellers Picker -->
        @defer (on viewport; on timer(10s); when isRestoringScroll()) {
          <app-category-picker class="category-picker"></app-category-picker>
        } @placeholder {
          <app-ui-skeleton />
        } @error {
          <span>loading</span>
        }

        <span class="fixed-space-32" aria-hidden="true"></span>
        <div class="faq">
          <!-- @if (lang !== 'AR') {
            <h1>Trade-In FAQ</h1>
          } @else {
            <h1>الأسئلة الشائعة حول المقايضة</h1>
          } -->

          @for (item of faqData; track item; let i = $index) {
            @if (
              (lang !== 'AR' && item.question.length) ||
              (lang === 'AR' && item.questionAr.length)
            ) {
              <div class="item">
                <div class="question" (click)="item.open = !item.open">
                  @if (lang !== 'AR') {
                    <span>{{ item.question }}</span>
                  }
                  @if (lang === 'AR') {
                    <span>{{ item.questionAr }}</span>
                  }
                  <span class="fixed-space-8" aria-hidden="true"></span>
                  <popsy-icon-chevron-down
                    class="icon icon fill-gray-01"
                    [class.selected]="item.open" />
                </div>
                @if (lang !== 'AR') {
                  <div
                    class="answer"
                    [class.selected]="item.open"
                    [innerHTML]="item.answer"></div>
                }
                @if (lang === 'AR') {
                  <div
                    class="answer"
                    [class.selected]="item.open"
                    [innerHTML]="item.answerAr"></div>
                }
                @if (i === 1 && item.open) {}
                <span class="line fill-row"></span>
              </div>
            }
          }
        </div>
      </main>
      <span class="fixed-space-32" aria-hidden="true"></span>
      <app-footer></app-footer>
    </div>
  </div>
</ng-container>
